module.exports = __webpack_public_path__ + "img/DynamicPickingS1Page.b50d8d8a.png";